// extracted by mini-css-extract-plugin
export default {"wrapper":"aq5Lb"};